var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-question-upLoadimg" },
    [
      _vm.fileListCopy.length > 0
        ? _c(
            "ul",
            { staticClass: "el-upload-list el-upload-list--picture-card" },
            _vm._l(_vm.fileListCopy, function (item) {
              return _c(
                "li",
                {
                  key: item.id,
                  staticClass: "el-upload-list__item is-success",
                  attrs: { tabindex: "0" },
                },
                [
                  _c(
                    "div",
                    [
                      _c("el-image", {
                        ref: "elImage",
                        refInFor: true,
                        staticStyle: { height: "50px", width: "50px" },
                        attrs: {
                          src: item.relativePath,
                          alt: item.name,
                          "preview-src-list": [item.relativePath],
                          fit: "cover",
                          "z-index": 99999,
                        },
                      }),
                      !_vm.readOnly
                        ? _c(
                            "span",
                            { staticClass: "el-upload-list__item-actions" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "el-upload-list__item-delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(item)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-error" })]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      !_vm.readOnly
        ? _c(
            "el-upload",
            {
              ref: "uploadPhotos",
              staticStyle: { display: "inline" },
              attrs: {
                action: _vm.dsf.url.getWebPath("/file/upload"),
                "on-error": _vm.handleAvatarError,
                "on-success": _vm.handleAvatarSuccess,
                "show-file-list": false,
                "on-change": _vm.handleChange,
                "on-exceed": _vm.handleExceed,
                "before-upload": _vm.beforeAvatarUpload,
                "list-type": "picture-card",
                "auto-upload": true,
                multiple: _vm.multiple,
                limit: _vm.limitNum,
              },
            },
            [
              _c("i", {
                staticClass: "iconfont icon-add",
                attrs: { slot: "default" },
                slot: "default",
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }